import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import * as actions from './actions'
import * as mutations from './mutations'
import * as getters from './getters'
import error from './modules/error'
import distributor from './modules/distributor'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const plugins = debug ? [createLogger()] : []

export default new Vuex.Store({
  actions,
  getters,
  mutations,
  modules: {
    error,
    distributor,
  },
  strict: debug,
  plugins: plugins,
})
